import React, { useEffect, useState } from 'react';
import { ModuleBridge, TopActionBar, Button } from '../components';
import { PlusOutlined } from '@ant-design/icons';
import { getUserRole } from '../lib/helpers';

export const Projects = () => {
    const [userRole, setuserRole] = useState(null);

    useEffect(() => {
        const role = getUserRole();
        setuserRole(role);
    }, []);

    return (
        <>
            <TopActionBar>
                <Button
                    type="primary"
                    className="button button--primary"
                    onClick={(e) => window.handlePrjAction(e)}
                    data-action="add-prj"
                    icon={<PlusOutlined />}
                    disabled={userRole === 'GLOBAL_ADMIN'}
                >
                    Add Project
                </Button>
            </TopActionBar>
            <div id="admin_projects_container"></div>
            <ModuleBridge moduleId="admin_projects_module" />
        </>
    );
};
